<template>
    <div class="container">
        <div class="fee-list" v-if="regFeeObject && regFeeObject.length > 0">
            <div v-for="(item, index) in regFeeObject" :key="index">
               <img src="../../assets/img/bank-success.png" alt=""> 
               <div class="details">
                   <p class="p1">{{handleCityName(item.registerCityName)}}代驾报名费</p>
                   <p class="p2">支付时间:{{item.payTime}}</p>
                   <p v-if="item.payStatus == 2 && item.failReason" class="p3">失败原因：{{item.failReason}}</p>
                   <p v-if="item.payStatus == 0 && item.remark" class="p3">{{item.remark}}</p>
               </div>
               <div class="details-r">
                   <p class="p1">¥{{calcPrice(item.money)}}</p>
                   <p class="p2">{{arrayFomatter(item.payStatus, payStatusData)}}</p>
               </div>
            </div>
        </div>
        <div v-else class="fee-no-data">
            <img src="https://carpool-1301582899.cos.ap-guangzhou.myqcloud.com/substituteDriving/fee-no-data.png">
        </div>
    </div>
</template>

<script>
import { queryRegFeeOrderList } from '@/apis/registration-fee/index';
import util from '@/utils/util';
import mobileType from '@/utils/mobileType';
export default {
    data() {
        return {
            data: {},
            regFeeObject: [],
            payStatusData: [
                {label: '退款中', value: 0},
                {label: '退款成功', value: 1},
                {label: '退款失败', value: 2},
                {label: '支付成功', value: 4},
            ]
        };
    },
    created() {
        //Vue的方法给原生调用，则需要把方法挂在Window下面
        window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
        // this._queryRegFeeInfo();
        if (this.$route.query.data) {
            let data = decodeURIComponent(this.$route.query.data);
            this.data = JSON.parse(data);
        }
        this.getUserInfoFromApp();
    },
    methods: {
        getUserInfoFromApp() {
            let params = {
                methodName: 'getDataFromNative', //定义与原生的方法名(固定)
                type: 1, //业务类型(固定)
            };
            if (mobileType.isIOS()) {
                //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
                window.webkit.messageHandlers.getDataFromVue.postMessage(params);
            } else if (mobileType.isAndroid()) {
                //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
                window.Android.getDataFromVue(JSON.stringify(params));
            } else {
            }
        },
        getDataFromNative(params) {
            if (mobileType.isIOS()) {
                this.params = params;
            } else if (mobileType.isAndroid()) {
                this.params = JSON.parse(params);
            }
            this._queryRegFeeInfo();
        },
        // 查询司机详情和物料信息
        async _queryRegFeeInfo(){
            // let params = {
            //     "areaCode": "110105",
            //     "channel": "1020000000",
            //     "data": "{}",
            //     "deviceId": "ffffffff-f53f-ae8b-ffff-ffffef05ac4a",
            //     "display": "1176*2328",
            //     "imei": "EEC72D61-F14A-4282-9CC0-121703E73A42",
            //     "platform": 1,
            //     "softVersion": "514",
            //     "sysVersion": "LIO-AN00,10",
            //     "token": "MTAxNzAwODE6NzAwOjIwMjEwOTA5MTgzNjUxMjQ2"
            // };
            let params = {
                areaCode: this.params.areaCode,
                channel: this.params.channel,
                deviceId: this.params.deviceId,
                display: this.params.display,
                imei: this.params.imei,
                imsi: this.params.imsi,
                platform: this.params.platform,
                softVersion: this.params.softVersion,
                sysVersion: this.params.sysVersion,
                data: {},
                token: this.params.token,
            };
            let _this = this;
            params.data = JSON.stringify(params.data);
            try {
                const data = await queryRegFeeOrderList(params);
                if (data.code == 1 && data.data) {
                    _this.regFeeObject = JSON.parse(data.data)
                }
            } catch (error) {
            }
        },
        calcPrice(val){
            return util.calcPrice(val)
        },
        arrayFomatter(val, arr){
            return util.arrayFomatter(val, arr)
        },
        handleCityName(val){
            let cityName = '';
            let num = val.indexOf('市');
            if(num != -1){
                cityName = val.substring(0, num+1)
            }else{
                cityName = val
            }
            return cityName;
        }
    },
};
</script>
<style scoped lang="less">
*{margin: 0;padding: 0;}
.fee-list{
    padding: 0 14px;
}
.fee-list > div{
    padding: 17px 0 18px;
    border-bottom: 1px solid #ECECEC;
}
.fee-list > div img{
    width: 24px;
    height: 24px;
    vertical-align: top;
    margin-top: 6px;
    margin-right: 8px;
}
.fee-list .details{
    display: inline-block;
}
.fee-list > div .p1{
        height: 17px;
    font-size: 12px;
    font-weight: 500;
    color: #000000;
    line-height: 17px;
    margin-bottom: 4px;
}
.fee-list .p2{
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    margin-bottom: 4px;
}
.fee-list .p3{
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #FFBF51;
    line-height: 17px;
}
.fee-list .details-r{
    display: inline-block;
    float: right;
    text-align: right;
}
.fee-no-data{
    padding: 134px 58px 0;
}
.fee-no-data img{
    width: 259px;
    height: 183px;
}
</style>

